import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import cx from 'classnames';

import Link from '../Link/Link';
import VerifiedInfo from '../VerifiedInfo/VerifiedInfo';
import Avatar from '../Avatar/Avatar';
import DropZone from './DropZone';
import Loader from '../Loader/Loader';
import history from '../../core/history';
import { doRemoveProfilePicture } from '../../actions/manageUserProfilePicture';
import messages from '../../locale/messages';

import viewProfile from '/public/SiteIcons/userViewProfile.svg';
import starReview from '/public/SiteIcons/starReview.svg';
import profileArrow from '/public/SiteIcons/viewProfileArrow.svg';
import { getSpecificConfig } from '../../helpers/getConfigValue';
import { CalendarDeleteIcon } from '../ListPlaceStep1/SyncCalendar/CalendarSvgComponent';

import s from './Dashboard.css';
import bt from '../../components/commonStyle.css';

const DashBoardSideMenu = ({ data, isProfilePage, isUser, hideMoreVerification }) => {
    const [location, setLocation] = useState('');
    const [maxUploadSize, setMaxUploadSize] = useState('');
    const intl = useIntl();
    const dispatch = useDispatch();

    const userData = useSelector((state) => state.account.data);
    const account = useSelector((state) => state.account.data);
    const profilePhotoLoading = useSelector((state) => state.account.profilePhotoLoading);
    const profilePhotoLoader = useSelector((state) => state.loader.profilePhotoLoader);
    const profilePictureData = useSelector((state) => state.profilePictureData || { loading: true });

    const { userId, picture } = account || {};
    const { loading, userAccount } = profilePictureData;

    useEffect(() => {
        if (history.location) {
            setLocation(history.location.pathname);
        }

        (async () => {
            const siteData = await getSpecificConfig({ name: ['maxUploadSize'] });
            setMaxUploadSize(siteData.maxUploadSize);
        })();
    }, []);

    useEffect(() => {
        if (history.location) {
            setLocation(history.location.pathname);
        }
    }, [history.location]);

    const handleRemovePicture = () => {
        if (account?.picture) {
            dispatch(doRemoveProfilePicture(account.picture));
        }
    };

    const isVerified = userData?.profileId;
    const showOwnProfile = !(isProfilePage && !isUser);
    const isReviewEnable = location === '/dashboard';

    return (
        <div>
            <div className={s.dashBoardSideMenu}>
                <div className={cx('positionRelative', s.profilePhotoWidth)}>
                    <Loader show={profilePhotoLoader} type="page">
                        <div className={cx(s.slideShow, bt.space3)}>
                            <Avatar
                                height={120}
                                width={120}
                                className={s.imgResponsive}
                                source={data?.picture}
                                isUser={showOwnProfile}
                            />
                            {!loading && userAccount?.picture && (
                                <a href="javascript:void(0);" onClick={handleRemovePicture}>
                                    <CalendarDeleteIcon className2={s.trashIcon} />
                                </a>
                            )}
                        </div>
                    </Loader>
                    {showOwnProfile && (
                        <>
                            {picture ? (
                                <DropZone data={data} isEditIcon />
                            ) : (
                                <DropZone
                                    data={data}
                                    defaultMessage={intl.formatMessage(messages.editProfilePhoto)}
                                />
                            )}
                        </>
                    )}
                </div>

                {showOwnProfile && picture && (

                    <div className={s.photoRemoveText}>
                        <a onClick={handleRemovePicture}>
                            <FormattedMessage {...messages.removePhotos} />
                        </a>
                    </div>
                )}
                <hr className={s.hr} />
                <VerifiedInfo
                    userId={data.userId || userId}
                    showOwnProfile={showOwnProfile}
                    hideMoreVerification={hideMoreVerification}
                />
            </div>

            {showOwnProfile && (
                <>
                    {!isReviewEnable && (
                        <Link
                            to="/user/reviews/about-you"
                            className={cx(s.reviewHeading, bt.spaceTop4, s.noTextDecoration, s.displayFlexIcons)}
                        >
                            <span>
                                <img src={starReview} className={cx(s.profileIcon, 'dashboardReviewStarRTL')} />
                                <FormattedMessage {...messages.reviews} />
                            </span>
                            <span className="svgImg">
                                <img src={profileArrow} className="dashboardReviewRTL" />
                            </span>
                        </Link>
                    )}
                    {!isProfilePage && (
                        <span className={cx({ [s.menuActive]: location === `/users/show/${isVerified}` })}>
                            <Link
                                to={`/users/show/${isVerified}`}
                                className={cx(
                                    s.reviewHeading,
                                    bt.spaceTop4,
                                    s.noTextDecoration,
                                    s.displayFlexIcons,
                                    s.activBtn
                                )}
                            >
                                <span>
                                    <img src={viewProfile} className={cx(s.profileIcon, 'dashboardReviewStarRTL')} />
                                    <FormattedMessage {...messages.viewProfile} />
                                </span>
                                <span className="svgImg">
                                    <img src={profileArrow} className="dashboardReviewRTL" />
                                </span>
                            </Link>
                        </span>
                    )}
                </>
            )}
        </div>
    );
};

DashBoardSideMenu.propTypes = {
    data: PropTypes.object,
    isProfilePage: PropTypes.bool,
    isUser: PropTypes.bool,
    hideMoreVerification: PropTypes.bool,
};

DashBoardSideMenu.defaultProps = {
    data: {},
    isProfilePage: false,
    isUser: true,
    hideMoreVerification: false,
};

export default withStyles(s, bt)(DashBoardSideMenu);
